import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuexI18n from "vuex-i18n";
import resourcePortuguese from "@/assets/resources/pt";
import * as resourceEnglish from "@/assets/resources/en.js";
import * as resourceChinese from "@/assets/resources/ch.js";
import "@/scss/mmf.scss";
import {BootstrapVue, BootstrapVueIcons} from "bootstrap-vue";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VeeValidate from 'vee-validate';
import Moment from "vue-moment";
import globalModal from "@/plugins/globalModal.js";
import automaticLoadingPanel from "@/plugins/automaticLoadingPanel.js";
import keycloakAdapter from "@/plugins/keycloakAdapter.js";
import authorizationAdapter from "@/plugins/authorizationAdapter.js";
import emAuthorizationAdapter from "@/plugins/emAuthorizationAdapter.js";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
// import emFitColumns from "@/plugins/emFitColumns.js";
import Keycloak from 'keycloak-js';
// import * as echarts from "echarts";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

import vcolorpicker from 'vcolorpicker';
//zTree3 2020-4-17º
import "@/plugins/zTree/js/jquery-3.4.1.min.js"
import "@/plugins/zTree/js/jquery.ztree.core.min.js"
import "@/plugins/zTree/js/jquery.ztree.excheck.min.js"

import './assets/icons' // icon
//DataV 2021-7-16
import dataV from '@jiaminghi/data-view'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCheckCircle,
    faExchangeAlt,
    faFileSignature,
    faIdCard,
    faInfo,
    faLightbulb,
    faPeopleCarry,
    faPlayCircle,
    faPowerOff,
    faScroll,
    faTasks,
    faUser
} from '@fortawesome/free-solid-svg-icons'
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'

//websocket
import emWebsocket from "@/plugins/emStomp";
import Print from 'vue-print-nb'

//wl-gantt
import wlGantt from 'wl-gantt'
import "wl-gantt/lib/wl-gantt.css"

import '@/plugins/video/video';

//html to pdf
import htmlToPdf from '@/utils/htmlToPdf.js'
import zxcvbn from "zxcvbn";
import EmptyApp from "@/EmptyApp";
import {_recordInteraction} from "@/plugins/user-interaction-record";

import {isNeedCleanApp} from "@/utils/mobileUtil";
import {_query, _queryIdByKey} from "@/plugins/configure-query-helper";

Vue.use(htmlToPdf)

library.add(faFileSignature, faIdCard, faLightbulb, faTasks, faPlayCircle, faCheckCircle, faScroll, faPowerOff, faPeopleCarry, faExchangeAlt, faUser, faInfo);

Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false
Vue.use(dataV)
Vue.use(Print)
Vue.use(vcolorpicker)
// Vue.use(emFitColumns)
Vue.use(wlGantt)
// Vue.prototype.$echarts = echarts;

// 防抖处理
const on = Vue.prototype.$on
Vue.prototype.$on = function (event, func) {
    let timer
    let newFunc = func
    if (event === 'click') {
        newFunc = function () {
            clearTimeout(timer)
            timer = setTimeout(function () {
                func.apply(this, arguments)
            }, 1000)
        }
    }
    on.call(this, event, newFunc)
}

//websocket
Vue.prototype.$webSocket = emWebsocket;
Vue.prototype.$zxcvbn = zxcvbn
Vue.config.ignoredElements = ['pdf-viewer','BrowserPrint-3.1.250.min.js','BrowserPrint-Zebra-1.1.250.min.js'];

//al user interaction
Vue.prototype.$interaction = _recordInteraction;
Vue.prototype.$query = _query;
Vue.prototype.$queryIdByCode = _queryIdByKey;

Vue.config.productionTip = false;

Vue.use(Moment);
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.use(vuexI18n.plugin, store);
Vue.use(globalModal, store);
Vue.use(automaticLoadingPanel, store);
Vue.component("v-select", vSelect);
// Vue.use(ElementUI, { i18n: (key, value) => i18n.t(key, value) })
// Vue.use(ElementUI, {
//     size: Cookies.get('size') || 'small' // set element-ui default size
// })
ElementUI.Dialog.props.appendToBody.default = true;
Vue.use(ElementUI);
Vue.i18n.add("en", resourceEnglish);
Vue.i18n.add("pt", resourcePortuguese);
Vue.i18n.add("ch", resourceChinese);
Vue.i18n.set("ch");
Vue.filter("formatFloat", value => {
    let number = 0
    if (value !== null && value !== '' && (value + "").indexOf(".") > 0 && !isNaN(value)) {
        number = parseFloat(value)
        number = Math.round(number * 100) / 100
        number = number.toFixed(2)
    } else {
        return value
    }
    return number === 'NaN' ? value : number
})

const config = {
    aria: true,
    classNames: {},
    classes: true,
    delay: 0,
    dictionary: null,
    errorBagName: 'errors', // change if property conflicts
    events: 'input|blur',
    fieldsBagName: 'fieldsBag',
    i18n: null, // the vue-i18n plugin instance
    i18nRootKey: 'validations', // the nested key under which the validation messages will be located
    inject: true,
    locale: 'en',
    validity: false
};

Vue.use(VeeValidate, config);

function setNewTokens(authenticated, keycloak) {
    if (!authenticated) {
        window.location.reload()
    }
    localStorage['kc_token'] = keycloak.token
    localStorage['kc_refreshToken'] = keycloak.refreshToken
    store.dispatch('auth/login', keycloak);
}

function getUrlParam(paramName) {
    var reg = new RegExp("(^|&)" + paramName + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
    var r = window.location.search.substr(1).match(reg); //匹配目标参数
    if (r != null) return decodeURI(r[2]);
    return null; //返回参数值
}

function setSession(authenticated, keycloak, i18n) {
    if (!authenticated) {
        window.location.reload()
    }
    store.dispatch('userPreferences/setSession', {
        keycloak: keycloak,
        i18n: i18n
    }, {
        root: true
    });

}

function setupKeycloak() {
    var configKeycloak = { // TODO
        url: process.env.VUE_APP_KEYCLOAK_URL,
        realm: process.env.VUE_APP_KEYCLOAK_REALM,
        clientId: process.env.VUE_APP_KEYCLOAK_CLINETID,
        credentials: {
            secret: process.env.VUE_APP_KEYCLOAK_CREDENTIALS_SECRET
        }
    }

    return new Promise((resolve, reject) => {
        var keycloak = Keycloak(configKeycloak);
        var initOptions = {
            onLoad: 'login-required'
        };
        if (localStorage['kc_token'] && localStorage['kc_token'] != 'undefined') {
            initOptions.token = localStorage['kc_token']
            initOptions.refreshToken = localStorage['kc_refreshToken']
            initOptions.timeSkew = 0
        }

        keycloak
            .init(initOptions)
            .success(authenticated => {
                setNewTokens(authenticated, keycloak)
                setSession(authenticated, keycloak, Vue.i18n)
                keycloak
                    .updateToken(600)
                    .success(function (refreshed) {
                        if (refreshed) {
                            setNewTokens(authenticated, keycloak);
                        }
                    })
                    .error(function () {
                        //alert('Failed to refresh token');
                    });

                Vue.use(keycloakAdapter, router, keycloak, store)
                Vue.use(authorizationAdapter, keycloak)
                Vue.use(emAuthorizationAdapter)
                resolve()
            })
            .error(function () {
                console.error('Failed to initialize');
                localStorage.removeItem('kc_token')
                localStorage.removeItem('kc_refreshToken')
                window.location.reload()
                reject()
            })

    })

}

function setupEmSso() {
    return new Promise((resolve) => {
        // let ssoApiBaseUrl = process.env.VUE_APP_EM_SSO_URL
        let urlJwt = getUrlParam("jwt");
        let urlCode = getUrlParam('code');
        let jwt = localStorage['em_sso_token']
        console.log("em sso jwt is :", jwt);
        //如果url中带了jwt，就更新localStorage中的jwt
        if (urlJwt != null && urlJwt !== "" && urlJwt !== undefined) {
            localStorage['em_sso_token'] = urlJwt;
            localStorage.removeItem('hideNoAuthMessage')
        }
        //from wechat
        else if (urlCode != null && urlCode !== '' && urlCode !== undefined) {
            let returnJson = JSON.stringify({
                code: urlCode,
                state: getUrlParam('state')
            });
            localStorage['return_url_fix'] = process.env.VUE_APP_WX_NEW_OPEN_ID_URL;
            localStorage['url_return_json'] = encodeURIComponent(returnJson);
            window.location.href = process.env.VUE_APP_EM_SSO_LOGIN_URL;
        } else {
            localStorage['return_url'] = window.location.href;
        }
        //如果有localStorageJwt，或者有urlJwt并设置为了localStorageJwt，就设置emAuthorization
        Vue.use(emAuthorizationAdapter, router, store);
        resolve()
    })
}

// Vue.config.warnHandler = function (warn) {
//     // console.warn(`Warning: ${warn.toString()}`);
// };
// Vue.config.errorHandler = function (err) {
//     console.error(`Error: ${err.toString()}`);
// };

if (process.env.VUE_APP_EM_SSO_ENABLE === 'true') {
    let jwt = localStorage['em_sso_token']
    let needCleanApp = isNeedCleanApp(window.location.pathname);
    const root = jwt && !needCleanApp ? App : EmptyApp
    setupEmSso().then(() => {
        new Vue({
            router,
            store,
            render: h => h(root)
        }).$mount("#app");
    })

} else {
    Vue.i18n.set("en");
    new Vue({
        router,
        store,
        render: h => h(App)
    }).$mount("#app");
}
